import { render, staticRenderFns } from "./tabMakeInvoice.vue?vue&type=template&id=38c725d1&"
import script from "./tabMakeInvoice.vue?vue&type=script&lang=js&"
export * from "./tabMakeInvoice.vue?vue&type=script&lang=js&"
import style0 from "./tabMakeInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c725d1')) {
      api.createRecord('38c725d1', component.options)
    } else {
      api.reload('38c725d1', component.options)
    }
    module.hot.accept("./tabMakeInvoice.vue?vue&type=template&id=38c725d1&", function () {
      api.rerender('38c725d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/makeInvoice/tabMakeInvoice.vue"
export default component.exports